export interface PillarArticleMeta {
  slug: string;
  tagKey: string;
  image: string;
  readingTime: string;
}

export const pillarArticles: PillarArticleMeta[] = [
  {
    slug: "usfans-spreadsheet-beginner-guide",
    tagKey: "tag.beginner",
    image: "https://readdy.ai/api/search-image?query=A%20person%20hands%20typing%20on%20a%20modern%20laptop%20with%20colorful%20product%20cards%20displayed%20on%20screen%2C%20bright%20white%20desk%20with%20coffee%20mug%2C%20natural%20daylight%2C%20clean%20productivity%20editorial%20photography%2C%20fresh%20organized%20aesthetic&width=800&height=600&seq=pillar-01&orientation=landscape",
    readingTime: "6",
  },
  {
    slug: "usfans-product-research-guide",
    tagKey: "tag.research",
    image: "https://readdy.ai/api/search-image?query=A%20vintage%20brass%20magnifying%20glass%20hovering%20over%20a%20collection%20of%20small%20fashion%20accessories%20on%20a%20light%20wooden%20table%2C%20bright%20natural%20side%20light%2C%20detective%20research%20aesthetic%20editorial%20photography%2C%20curious%20investigative%20mood&width=800&height=600&seq=pillar-02&orientation=landscape",
    readingTime: "7",
  },
  {
    slug: "usfans-qc-guide",
    tagKey: "tag.qc",
    image: "https://readdy.ai/api/search-image?query=A%20detailed%20close-up%20of%20a%20quality%20inspection%20process%20with%20a%20measuring%20tape%20and%20checklist%20paper%20next%20to%20a%20product%20box%2C%20clean%20white%20studio%20background%2C%20precise%20professional%20editorial%20photography%2C%20quality%20control%20theme&width=800&height=600&seq=pillar-03&orientation=landscape",
    readingTime: "5",
  },
  {
    slug: "usfans-shipping-guide",
    tagKey: "tag.shipping",
    image: "https://readdy.ai/api/search-image?query=A%20small%20cardboard%20shipping%20package%20resting%20on%20a%20digital%20weighing%20scale%20with%20a%20world%20map%20and%20shipping%20labels%20in%20the%20background%2C%20bright%20clean%20logistics%20photography%2C%20global%20delivery%20theme&width=800&height=600&seq=pillar-04&orientation=landscape",
    readingTime: "6",
  },
  {
    slug: "usfans-warehouse-guide",
    tagKey: "tag.warehouse",
    image: "https://readdy.ai/api/search-image?query=Rows%20of%20neatly%20organized%20cardboard%20storage%20boxes%20on%20modern%20warehouse%20shelving%20with%20barcode%20labels%2C%20bright%20industrial%20lighting%2C%20clean%20modern%20logistics%20photography%2C%20organized%20inventory%20theme&width=800&height=600&seq=pillar-05&orientation=landscape",
    readingTime: "5",
  },
  {
    slug: "usfans-safety-guide",
    tagKey: "tag.safety",
    image: "https://readdy.ai/api/search-image?query=A%20sleek%20metallic%20security%20shield%20icon%20placed%20on%20a%20modern%20glass%20desk%20with%20a%20subtle%20lock%20and%20key%20beside%20it%2C%20soft%20ambient%20lighting%2C%20cybersecurity%20and%20safety%20editorial%20photography%2C%20trustworthy%20protective%20mood&width=800&height=600&seq=pillar-06&orientation=landscape",
    readingTime: "6",
  },
  {
    slug: "usfans-categories-guide",
    tagKey: "tag.categories",
    image: "https://readdy.ai/api/search-image?query=A%20colorful%20grid%20of%20different%20fashion%20product%20category%20thumbnails%20displayed%20on%20a%20tablet%20screen%20with%20hands%20holding%20it%2C%20bright%20modern%20lifestyle%20photography%2C%20organized%20digital%20shopping%20theme&width=800&height=600&seq=pillar-07&orientation=landscape",
    readingTime: "5",
  },
  {
    slug: "usfans-compare-guide",
    tagKey: "tag.compare",
    image: "https://readdy.ai/api/search-image?query=Two%20similar%20products%20side%20by%20side%20on%20a%20clean%20comparison%20table%20with%20a%20checklist%20paper%20between%20them%2C%20bright%20balanced%20studio%20lighting%2C%20analytical%20shopping%20editorial%20photography%2C%20decision-making%20theme&width=800&height=600&seq=pillar-08&orientation=landscape",
    readingTime: "6",
  },
  {
    slug: "usfans-coupon-guide",
    tagKey: "tag.coupon",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20golden%20scissors%20cutting%20a%20red%20discount%20coupon%20ticket%20with%20confetti%20around%2C%20celebratory%20bright%20studio%20photography%2C%20promotional%20sale%20and%20savings%20theme%2C%20cheerful%20vibrant%20mood&width=800&height=600&seq=pillar-09&orientation=landscape",
    readingTime: "5",
  },
  {
    slug: "usfans-seller-guide",
    tagKey: "tag.seller",
    image: "https://readdy.ai/api/search-image?query=Two%20professional%20hands%20shaking%20over%20a%20polished%20wooden%20conference%20table%20with%20business%20documents%20and%20a%20small%20gift%20box%2C%20warm%20office%20lighting%2C%20trust%20and%20partnership%20editorial%20photography%2C%20business%20agreement%20theme&width=800&height=600&seq=pillar-10&orientation=landscape",
    readingTime: "6",
  },
];